import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import type { CancelRequestTarget } from './dataUpdateTargets';

export interface DataUpdateCancelDialogProps {
  target: CancelRequestTarget | null;
  isCancelling: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * データ更新ジョブのキャンセル確認ダイアログ。
 * `TabConfigContent`（タブの並びの変化で remount される）の外、`TabConfigScreen` 直下に置き、
 * ポーリング中の他ユーザー操作で無言で閉じないようにする。
 */
export function DataUpdateCancelDialog({
  target,
  isCancelling,
  onConfirm,
  onClose,
}: DataUpdateCancelDialogProps) {
  return (
    <AlertDialog
      open={target !== null}
      onOpenChange={(open) => {
        if (!open && !isCancelling) onClose();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>データ更新ジョブをキャンセルしますか？</AlertDialogTitle>
          <AlertDialogDescription>
            実行中のジョブを中止し、失敗として記録します。作成済みの公開データは変更されません。
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isCancelling}>閉じる</AlertDialogCancel>
          {/* AlertDialogAction は Radix の Dialog.Close 実装で、onClick 後に自動で
              onOpenChange(false) を呼ぶ。setIsCancelling(true) の反映前にそれが走ると
              isCancelling ガードが効かないまま閉じてしまうため、既定動作を止めて
              DELETE 完了後（confirmCancel の finally）に閉じるようにする。 */}
          <AlertDialogAction
            onClick={(event) => {
              event.preventDefault();
              onConfirm();
            }}
            disabled={isCancelling}
          >
            中止する
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
